import { ShortCode } from '@highereducation/wordpress';
import { Heading } from '@highereducation/hen-ui';

interface HeadingShortcodeProps {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  color?: 'default' | 'white';
  align?: 'left' | 'center' | 'right';
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * HeadingShortcode - Shortcode wrapper for Heading atomic component
 *
 * Supported shortcode attributes:
 * - variant: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' (default: 'h1') - Heading level
 * - color: 'default' | 'white' (default: 'default') - Text color
 * - align: 'left' | 'center' | 'right' - Text alignment
 *
 * @example WordPress shortcode usage:
 * [hen-ui-heading variant="h2"]My Heading[/hen-ui-heading]
 * [hen-ui-heading variant="h2" color="white"]White Heading[/hen-ui-heading]
 * [hen-ui-heading variant="h2" align="center"]Centered Heading[/hen-ui-heading]
 */
export const HeadingShortcode: ShortCode<HeadingShortcodeProps> = {
  component: ({ variant = 'h1', color, align, children }) => {
    return (
      <Heading variant={variant} color={color} align={align}>
        {children}
      </Heading>
    );
  },
};
